import { defineDefaultEnumValue, defineEnumClampFunction } from 'src/lib/enum';

/**
 * Page view types
 * @enum {string}
 * @property {PAGE_VIEW} DEFAULT - default page view
 * @property {EnumClampFunction<PAGE_VIEW>} clamp - function that clamps the value to the enum
 */
export const PAGE_VIEW = {
  chart: 'chart',
  table: 'table',
};
defineDefaultEnumValue(PAGE_VIEW, PAGE_VIEW.table);
defineEnumClampFunction(PAGE_VIEW, PAGE_VIEW.table);

const PAGE_VIEW_LABEL = {
  [PAGE_VIEW.chart]: 'Analytics',
  [PAGE_VIEW.table]: 'Data rows',
};

export const getPageViewLabel = (view) => {
  return PAGE_VIEW_LABEL[view] || '';
};
